import React from 'react'
import Button from '../../atoms/button/button';
import './purposeBanner.scss';

type TPurposeBanner = {
	title: string;
	description: string;
	backgroundImage: string;
	buttonText?: string;
	onClick?: any;
	yPosition?: string;
}

const PurposeBanner = (props: TPurposeBanner) => {

	const {title, description, backgroundImage, buttonText, onClick = () => {}, yPosition} = props
	let parsedYPosition = "50%";
	if (yPosition && /^[1-9][0-9]?\d?%$/.test(yPosition)) {
		parsedYPosition = yPosition;
	}

	       return (
		       <div className="purpose-banner" role="banner" style={{backgroundImage: `url(${backgroundImage})`, backgroundPositionY: parsedYPosition}}>
			<div className="purpose-banner__info">
				<h2>{title}</h2>
				<h3>{description}</h3>
			</div>
			{buttonText && <Button text={buttonText} gtmClass='secondary' onClick={onClick} />}
		</div>
	)
}

export default PurposeBanner